import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: contents;
}`],
})
export class ComponentNavSidebarComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public routerSub: any;
    public selectedMain: string = '';
    public selectedCat: string = '';
    public activeSub: string = '';

    public menuItems: any[] = [
        { label: '홈', icon: 'home', link: '/' },
        {
            label: '기초관리', icon: 'cog', link: '/basic',
            children: [
                { key: 'store', label: '매장관리', items: ['매장정보관리', '사원정보관리', '사원정보조회', '패스워드변경', 'VAN/코너 정보', '테이블속성', '테이블관리', '포스기능정의'] },
                { key: 'print', label: '출력물관리', items: ['포스출력물관리', '포스출력물로그', '바코드출력환경', '바코드출력'] },
                { key: 'product', label: '상품관리', items: ['상품기초정보등록', '거래처등록', '거래처엑셀업로드', '거래처조회', '상품등록', '상품조회', '상품엑셀업로드', '간편상품등록', '상품정보일괄변경', '상품바코드등록', '사이드메뉴등록', '판매터치키등록', '주방프린터-상품연결', '주방프린터-시간대제어'] },
                { key: 'price', label: '가격관리', items: ['판매가관리', '매장판매가 History', '판매가현황', '원가임의변경', '원가변경 History'] },
                { key: 'payment', label: '결제수단', items: ['제휴카드등록', '상품권등록', '식권등록', '쿠폰등록', '고정할인등록'] },
                { key: 'etc', label: '기타관리', items: ['명칭관리', '예약관리(웹전용)', '주방메모관리', '배달구역관리'] },
                { key: 'kiosk', label: '키오스크관리', items: ['키오스크 이미지관리', '다국어 관리', '키오스크터치키관리', '품절일괄변경'] },
                { key: 'kiosk2', label: '키오스크관리(2.0전용)', items: ['할인/판매 시간관리', '키오스크 터치키 관리'] },
                { key: 'qrorder', label: 'QR오더 & 페이관리', items: ['QR오더 터치키 관리'] },
                { key: 'kiosknaver', label: '키오스크관리(Naver)', items: ['키오스크 관리'] },
            ]
        },
        {
            label: '매출관리', icon: 'chart', link: '/sales',
            children: [
                { key: 'status', label: '매출현황', items: ['당일매출종합현황', '당일매출상세현황', '영수증일자별매출상세현황', '일자별', '요일별', '월별', '일기간', '테이블별', '포스별', '상품별', '매장상품별', '판매자별', '주문자별', '컵보증금 판매현황', '할인구분별', '바코드별', '반품현황', 'POS정산내역'] },
                { key: 'analysis', label: '매출분석', items: ['대비기간매출분석', '상품ABC분석', '월력판매분석', '판매추이분석', '영업일보', '매출목표관리', '상품별월매출조회'] },
                { key: 'order', label: '주문분석', items: ['주문취소'] },
                { key: 'approval', label: '승인현황', items: ['승인현황', '모바일쿠폰승인현황'] },
                { key: 'delivery', label: '배달현황', items: ['배달현황', '배달대행서비스'] },
                { key: 'misc', label: '기타', items: ['객수매출현황'] },
            ]
        },
        {
            label: '회원관리', icon: 'users', link: '/member',
            children: [
                { key: 'info', label: '회원정보', items: ['회원등급설정', '회원정보조회', '회원정보등록', '회원정보일괄변경', '배달지조회및변경', '회원엑셀업로드', '회원포인트조정'] },
                { key: 'analysis', label: '회원분석', items: ['일자별회원구매내역', '기간회원구매내역', '회원-상품 구매내역', '회원구매성향분석', '회원매출점유', '회원포인트실적', '외상발생/입금내역', '회원미수금현황', '회원유치사원별매출내역', '상품-회원 구매내역'] },
            ]
        },
        {
            label: '기타관리', icon: 'folder', link: '/other',
            children: [
                { key: 'cash', label: '금전처리', items: ['계정관리', '금전현황', '돈통오픈기록'] },
                { key: 'attendance', label: '근태관리', items: ['근태관리', '월근태내역', '시급관리'] },
                { key: 'sms', label: 'SMS관리', items: ['메세지관리', '문자전송현황', 'SMS충전', 'SMS충전내역', 'SMS자동전송관리', 'SMS기념일전송관리', 'SMS주문취소전송관리'] },
            ]
        },
    ];

    public async ngOnInit() {
        await this.service.init();
        this.syncFromUrl();
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.syncFromUrl();
                await this.service.render();
            }
        });
        await this.service.render();
    }

    ngOnDestroy() { if (this.routerSub) this.routerSub.unsubscribe(); }

    private syncFromUrl() {
        const path = location.pathname;
        for (let item of this.menuItems) {
            if (!item.children) continue;
            if (path === item.link || path.startsWith(item.link + '/')) {
                this.selectedMain = item.label;
                for (let child of item.children) {
                    const childLink = item.link + '/' + child.key;
                    if (path === childLink || path.startsWith(childLink + '/')) {
                        this.selectedCat = child.key;
                        const parts = path.split('/');
                        if (parts.length >= 4) {
                            try { this.activeSub = decodeURIComponent(parts.slice(3).join('/')); } catch { this.activeSub = parts.slice(3).join('/'); }
                        } else {
                            this.activeSub = '';
                        }
                        return;
                    }
                }
                this.selectedCat = '';
                this.activeSub = '';
                return;
            }
        }
        this.selectedMain = '';
        this.selectedCat = '';
        this.activeSub = '';
    }

    public getSelectedMainItem(): any {
        return this.menuItems.find((m: any) => m.label === this.selectedMain);
    }

    public getSelectedCatItem(): any {
        const main = this.getSelectedMainItem();
        if (!main || !main.children) return null;
        return main.children.find((c: any) => c.key === this.selectedCat);
    }

    public selectMain(item: any) {
        if (!item.children) {
            this.selectedMain = '';
            this.selectedCat = '';
            this.service.href(item.link);
            return;
        }
        this.selectedMain = item.label;
        this.selectedCat = '';
        this.activeSub = '';
        this.service.render();
    }

    public selectCat(child: any) {
        this.selectedCat = child.key;
        this.activeSub = '';
        this.service.render();
    }

    public navigateToItem(itemLabel: string) {
        this.activeSub = itemLabel;
        const mainItem = this.getSelectedMainItem();
        const catItem = this.getSelectedCatItem();
        if (mainItem && catItem) {
            this.service.href(`${mainItem.link}/${catItem.key}/${encodeURIComponent(itemLabel)}`);
        }
    }

    public isMainActive(item: any): boolean {
        if (item.link === '/') return location.pathname === '/';
        return this.selectedMain === item.label;
    }

    public isCatActive(child: any): boolean {
        return this.selectedCat === child.key;
    }

    public isSubActive(itemLabel: string): boolean {
        return this.activeSub === itemLabel;
    }
}

export default ComponentNavSidebarComponent;